import React, { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Typography, Button, Stack } from "@mui/material";
import api from "../../api/axios";
// console.log("VendorOrderDetails loaded");
const VendorOrderDetails = () => {
  const { orderId } = useParams(); // this is Mongo _id
  const navigate = useNavigate();

  const [order, setOrder] = useState(null);
  const vendor = JSON.parse(localStorage.getItem("user"));

  // ⛔ Protect vendor route
  useEffect(() => {
    if (!vendor?._id) {
      navigate("/vendor/login", { replace: true });
    }
  }, [vendor, navigate]);

  // 📦 Fetch single order
  const fetchOrder = useCallback(async () => {
    try {
      const { data } = await api.get(`/vendor/orders/${orderId}`,
        {
          params: { vendorId: vendor._id },
        }
      );

      setOrder(data);
    } catch (error) {
      console.error("Failed to load order:", error);
      navigate("/vendor/orders", { replace: true });
    }
  }, [orderId, vendor?._id, navigate]);

  useEffect(() => {
    if (vendor?._id && orderId) {
      fetchOrder();
    }
  }, [fetchOrder]);

  // 🔄 Update order status
  const updateStatus = async (status) => {
    try {
      await api.patch(
        `/vendor/orders/${orderId}/status`,
        { status },
        {
    params: { vendorId: vendor._id },
  },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      fetchOrder(); // refresh latest order state
    } catch (error) {
      console.error("Failed to update status:", error);
    }
  };

  if (!order) return null;

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h6" fontWeight={700}>
        Order ID: {order._id}
      </Typography>

      <Typography sx={{ mt: 2 }}>
        Current Status: {order.tracking?.at(-1)?.label}
      </Typography>

      <Stack spacing={2} mt={4}>
        {order.status === "ORDER_PLACED" && (
          <Button
            variant="contained"
            onClick={() => updateStatus("VENDOR_ACCEPTED")}
          >
            Accept Order
          </Button>
        )}

        {order.status === "VENDOR_ACCEPTED" && (
          <Button
            variant="contained"
            onClick={() => updateStatus("LOOKING_FOR_AGENT")}
          >
            Looking for Agent
          </Button>
        )}
{/* ******************* */}
        {order.status === "LOOKING_FOR_AGENT" && (
          <Button
            variant="contained"
            onClick={() => updateStatus("AGENT_ASSIGNED")}
          >
            Agent Assigned
          </Button>
        )}
{/* ******************* */}
        {order.status === "AGENT_ASSIGNED" && (
          <Button
            variant="contained"
            onClick={() => updateStatus("MANUFACTURING")}
          >
            Product Manufacturing
          </Button>
        )}

        {order.status === "MANUFACTURING" && (
          <Button
            variant="contained"
            onClick={() => updateStatus("INTERNATIONAL_TRANSIT")}
          >
            International Transit
          </Button>
        )}

        {order.status === "INTERNATIONAL_TRANSIT" && (
          <Button
            variant="contained"
            onClick={() => updateStatus("CUSTOMS_CLEARANCE")}
          >
            Customs Clearance
          </Button>
        )}
         {order.status === "CUSTOMS_CLEARANCE" && (
          <Button
            variant="contained"
            onClick={() => updateStatus("LOCAL_TRANSIT")}
          >
            Local Transit
          </Button>
        )}
        {order.status === "LOCAL_TRANSIT" && (
          <Button
            variant="contained"
            onClick={() => updateStatus("DELIVERED")}
          >
            Delivered
          </Button>
        )}
      </Stack>
    </Box>
  );
};

export default VendorOrderDetails;
